import { apiRequest } from '@/lib/api-client';

export interface ThemeCategory {
  id: string;
  slug: string;
  name: string;
  emoji?: string | null;
  description?: string | null;
  display_order: number;
  is_active: boolean;
}

export interface Theme {
  id: string;
  slug: string;
  label: string;
  subtitle?: string | null;
  prompt_text: string;
  emoji?: string | null;
  description?: string | null;
  category_id?: string | null;
  is_active: boolean;
  display_order: number;
  min_grade_level: number;
  max_grade_level: number;
  cognitive_complexity: string;
  emotional_complexity: string;
}

export const themesApi = {
  async getCategories(): Promise<ThemeCategory[]> {
    return apiRequest<ThemeCategory[]>('/stories/theme-categories', {}, 'Failed to fetch theme categories');
  },

  async getThemes(gradeLevel?: number, categoryId?: string): Promise<Theme[]> {
    const params = new URLSearchParams();
    if (gradeLevel) params.append('grade_level', gradeLevel.toString());
    if (categoryId) params.append('category_id', categoryId);

    const url = params.toString()
      ? `/stories/themes?${params.toString()}`
      : '/stories/themes';
    return apiRequest<Theme[]>(url, {}, 'Failed to fetch themes');
  },
};
